"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionManager = void 0;
class TransactionManager {
    constructor() {
        this.sendTransaction = async (_provider, rawTransaction, wallet) => {
            if (_provider && rawTransaction) {
                if (wallet === undefined) {
                    const transactionHash = await _provider.send("eth_sendTransaction", [rawTransaction]);
                    const response = {
                        hash: transactionHash,
                        wait: (confirmations) => {
                            return _provider.waitForTransaction(transactionHash, confirmations);
                        }
                    };
                    return response;
                }
                else {
                    const unsignedTx = rawTransaction;
                    unsignedTx.nonce = await _provider.getTransactionCount(wallet.address);
                    const { chainId } = await _provider.getNetwork();
                    unsignedTx.chainId = chainId;
                    unsignedTx.gasPrice = await _provider.getGasPrice();
                    unsignedTx.gasLimit = await _provider.estimateGas(unsignedTx);
                    const signedTx = await wallet.signTransaction(unsignedTx);
                    return this.sendSignedTransaction(_provider, signedTx);
                }
            }
            else {
                throw new Error("Error while sending transaction. Either provider or rawTransaction is not defined");
            }
        };
        this.sendSignedTransaction = async (_provider, signedTransaction) => {
            if (_provider && signedTransaction) {
                const transactionHash = await _provider.send("eth_sendRawTransaction", [signedTransaction]);
                const response = {
                    hash: transactionHash,
                    wait: (confirmations) => {
                        return _provider.waitForTransaction(transactionHash, confirmations);
                    }
                };
                return response;
            }
            else {
                throw new Error("Error while sending transaction. Either provider or signedTransaction is not defined");
            }
        };
    }
}
exports.TransactionManager = TransactionManager;
